import { EMPTY_FILTERS } from './slabModel.mjs';

export function readBrowseSession(storage, key) {
  try {
    const saved = JSON.parse(storage?.getItem(key));
    if (!saved || saved.version !== 1) return null;
    const filters = { ...EMPTY_FILTERS };
    for (const [name, fallback] of Object.entries(EMPTY_FILTERS)) {
      const value = saved.filters?.[name];
      if (Array.isArray(fallback) && Array.isArray(value)) filters[name] = value.filter(item => typeof item === 'string').slice(0, 400);
      else if (typeof fallback === 'string' && typeof value === 'string') filters[name] = value.slice(0, 500);
    }
    return { query: typeof saved.query === 'string' ? saved.query.slice(0, 500) : '', filters, selectedKey: typeof saved.selectedKey === 'string' ? saved.selectedKey.slice(0, 200) : null };
  } catch { return null; }
}

export function saveBrowseSession(storage, key, value) {
  if (!storage || !key) return;
  try { storage.setItem(key, JSON.stringify({ version: 1, query: value.query, filters: value.filters, selectedKey: value.selectedKey })); } catch { /* browsing also works with storage disabled */ }
}
